@if (isMobileOpen) {
<div
  class="fixed inset-0 z-40 bg-black/40 lg:hidden"
  (click)="closeMobileSidebar()"
  aria-hidden="true"></div>
}
<aside
  [class.-translate-x-full]="!isMobileOpen"
  [class.w-24]="isCollapsed"
  [class.w-[260px]]="!isCollapsed"
  class="fixed inset-y-0 left-0 z-50 flex h-full shrink-0 flex-col border-r border-gray-200 bg-white shadow-[0px_4px_12px_0px_rgba(71,75,197,0.15)] transition-all duration-300 ease-in-out lg:static lg:translate-x-0">
  <!-- Logo & collapse toggle -->
  <div
    class="relative flex min-h-[5rem] shrink-0 items-center pb-4 pt-8"
    [class.pl-8]="!isCollapsed"
    [class.justify-center]="isCollapsed">
    <div class="flex items-center gap-1">
      <img
        [src]="imageEnum.COMPANY_LOGO_BLUE"
        alt="Charaka"
        class="mt-1 w-auto object-contain transition-all duration-300"
        [class.h-[34px]]="!isCollapsed"
        [class.h-[42px]]="isCollapsed" />
      @if (!isCollapsed) {
        <span
          class="mt-1.5 font-serif text-[28px] font-bold lowercase leading-none text-brand-primary md:text-[34px]"
          >haraka</span
        >
      }
    </div>

    <button
      type="button"
      (click)="toggleCollapsed()"
      class="absolute -right-3 top-[76%] z-50 hidden h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full bg-brand-primary text-white shadow-[0_2px_8px_rgba(72,76,201,0.4)] transition-all duration-300 hover:bg-opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary/30 lg:flex"
      [attr.aria-label]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="h-3 w-3 transition-transform duration-200"
        [class.rotate-180]="isCollapsed"
        aria-hidden="true">
        <path d="m15 18-6-6 6-6" />
      </svg>
    </button>
  </div>

  <!-- Navigation -->
  <div class="mt-2 flex w-full flex-1 flex-col overflow-y-auto pb-8">
    <nav
      class="mt-1 flex flex-1 flex-col gap-2"
      [class.px-6]="!isCollapsed"
      [class.px-4]="isCollapsed"
      aria-label="Main navigation">
      @for (item of navItems; track $index) {
        <a
          [routerLink]="item.route"
          routerLinkActive
          [routerLinkActiveOptions]="{ exact: item.exact !== false }"
          #navLink="routerLinkActive"
          [attr.aria-label]="item.label"
          [title]="isCollapsed ? item.label : ''"
          [ngClass]="[
            isCollapsed ? 'mx-auto h-11 w-11 flex-none justify-center p-0' : 'gap-3 px-4 py-2.5',
            navLink.isActive
              ? 'bg-button-gradient font-semibold text-white'
              : 'font-normal text-black hover:bg-gray-50'
          ]"
          class="relative flex items-center rounded-xl text-[14px] transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary/30"
          (click)="closeMobileSidebar()">
          <img
            [src]="navLink.isActive ? item.activeIcon : item.icon"
            alt=""
            class="h-[1.15rem] w-[1.15rem] shrink-0" />
          @if (!isCollapsed) {
            <span class="whitespace-nowrap tracking-wide">{{ item.label }}</span>
          }
        </a>
      }
    </nav>
  </div>
</aside>
